import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'mobx-react';
import { ScreenClassProvider } from 'react-grid-system';
import { configure } from 'mobx';
import AppRouter from './AppRouter';
const RenderRouter = () => React.createElement(AppRouter, null);
configure({
    enforceActions: 'never'
});
// md3: the MUI ThemeProvider/createTheme wrapper is gone — the md3 theme is plain
// scoped CSS (`.md3` + autobahn.css), no JS theme context needed.
const AppProvider = ({ store, i18next }) => {
    return (React.createElement(I18nextProvider, { i18n: i18next },
        React.createElement(Provider, { ...store },
            React.createElement(ScreenClassProvider, null, RenderRouter()))));
};
export default AppProvider;
